@if (statusData() !== 'error') {
  <div
    class="rate-table"
    role="region"
    [attr.aria-label]="'Tabla de tasas financieras'"
  >
    @if (statusData() !== 'loading') {
      <span
        class="rate-table__item"
        tooltip="Tasa diaria de mora"
        [attr.aria-label]="'Tasa diaria de mora: ' + (rateData ? rateData.rate.daily_nominal_usury_rate : 'N/A') + ' por ciento'"
      >
        <img
          src="assets/img/tabler/calendar.svg"
          alt=""
          class="rate-table__icon"
          aria-hidden="true"
        />
        <span class="rate-table__label">Mora diaria</span>
        <span class="rate-table__badge">
          {{ rateData ? rateData.rate.daily_nominal_usury_rate : 'N/A' }}%
        </span>
      </span>
      <span
        class="rate-table__item"
        tooltip="Tasa máxima de mora permitida EA"
        [attr.aria-label]="'Tasa máxima de mora permitida EA: ' + (rateData ? rateData.rate.effective_annual_rate : 'N/A') + ' por ciento'"
      >
        <img
          src="assets/img/tabler/percentage.svg"
          alt=""
          class="rate-table__icon"
          aria-hidden="true"
        />
        <span class="rate-table__label">Mora máx. EA</span>
        <span class="rate-table__badge">
          {{ rateData ? rateData.rate.effective_annual_rate : 'N/A' }}%
        </span>
      </span>
      <a
        [href]="superMayorLink"
        target="_blank"
        rel="noopener noreferrer"
        class="rate-table__item rate-table__item--link"
        tooltip="Interés bancario corriente"
        [attr.aria-label]="'Interés bancario corriente: ' + (rateData ? rateData.rate.effective_annual_current_rate : 'N/A') + ' por ciento. Enlace a Superintendencia Financiera'"
      >
        <img
          src="assets/img/tabler/building.svg"
          alt=""
          class="rate-table__icon"
          aria-hidden="true"
        />
        <span class="rate-table__label">IBC</span>
        <span class="rate-table__badge">
          {{ rateData ? rateData.rate.effective_annual_current_rate : 'N/A' }}%
        </span>
      </a>
    } @else {
      <section class="loader-wrapper" role="status" [attr.aria-label]="'Cargando tasas financieras'">
        <loader></loader>
      </section>
    }
  </div>
}
